import {HTTP, HTTPAUTH} from '../../utils/http-base';
import store from 'store';
import router from '@/router';
import objectToFormData from 'object-to-formdata'; 

// initial state
const state = {
 	surveys : [],
  surveyStats : []
}

// getters
const getters = {
  surveyStats(state){
    return state.surveyStats
  },
  getRequestedSurveys(state){
    return state.surveys.filter((surveyData) => {
       return surveyData.survey.surveyStatus === 0
    })
  },
  getOpenSurveys(state){
    return state.surveys.filter((surveyData) => {
       return surveyData.survey.surveyStatus === 1
    })
  },
  getQuotations(state){
    return state.surveys.filter((surveyData) => {
      return surveyData.survey.surveyStatus === 0 || surveyData.survey.surveyStatus === 1 
    })
  },
  getOnGoingSurveys(state){
    return state.surveys.filter((surveyData) => {
      return surveyData.survey.surveyStatus === 2
    })
  },
  getCompletedSurveys(state){
    return state.surveys.filter((surveyData) => {
      return surveyData.survey.surveyStatus === 3
    }).sort((a, b) => {
     
      return new Date(b.survey.completed) - new Date(a.survey.completed);
    })
  }
}

// actions
const actions = {
  createSurvey : ({commit, dispatch}, surveyData) => {
      return new Promise((resolve, reject) => {
      		HTTPAUTH.post('/api/surveys', surveyData)
      		.then((response) => {
      			let data = response.data;
      			if(data.confirmation === 'fail'){
      				reject(data);
      				return;
      			}

      			if(data.confirmation === 'success'){
      				commit('removeAreas');
      				commit('removeAllAreasLocalStorage', []);
      				commit('addSurvey', data.data);
              router.push({path : '/create/quote-requested'})
      				resolve(data);
      				return;
      			}

      		})
      		.catch((err) => {
      			reject(err);
      		})
	       	
      })
  },

  getSurveyStats : ({commit}) => {

      HTTPAUTH.get('/api/users/surveystats')
      .then((response) => {
       
          let data = response.data;
      
          if(data.confirmation === 'success'){
         
            commit('setLoadedSurveyStats', data.data);
            return;
          }

      })
     .catch((err) => {
          console.log(err);
      });
      
  },

  loadSurveys : ({commit, rootState, dispatch}) => {
    dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait'});
     HTTPAUTH.get('/api/surveys')
     .then((response) => {
          let data = response.data;
          if(data.confirmation === 'success'){
            commit('setLoadedSurveys', data.data);
          } 
          return HTTPAUTH.get('/api/surveys?surveyStatus=3')
     })
     .then((response) => {
        let data = response.data;
        if(data.confirmation === 'success'){
          commit('setLoadedSurveys', data.data);
        }
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
     })
     .catch((err) => {
       console.log(err);
       dispatch('setIsWaiting', {isWaiting : false, message : ''});
     })
  },

  deleteSurvey : ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.delete('/api/surveys/' + payload.quoteReference)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        let data = response.data;
        if(data.confirmation == 'success'){
          resolve(data);
          if(payload.type === 'Quotes Requested'){
            commit('surveyStatsAlterRequestedQuotes', payload.quoteReference)
          }
          if(payload.type === 'Open Quotations'){
            commit('surveyStatsAlterOpenQuotes');
          }
          commit('removeOneSurvey', payload.quoteReference)
          
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  sendSurveyQuote : ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.post('/api/surveys/' + payload.quoteReference + '/addquote', objectToFormData(payload.data))
      .then((response) => {
        let data = response.data;
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        if(data.confirmation == 'success'){

          resolve(data);
          commit('updateOneSurvey', data.data);
          commit('updateOpenQuotationStats')
          commit('surveyStatsAlterRequestedQuotes');
          
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  completeSurvey : ({commit ,dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      console.log('Started promise');
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.post('/api/surveys/' + payload.quoteReference + '/addsurvey', objectToFormData(payload.data))
      .then((response) => {
        console.log('DB Response?');
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        let data = response.data;
        if(data.confirmation == 'success'){

          resolve(data);
          commit('updateOneSurveyAndAddToBeginning', data.data);
          commit('completeSurveyStats')
          
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  updateSurveyQuote : ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.put('/api/surveys/' + payload.quoteReference + '/addquote', objectToFormData(payload.data))
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        let data = response.data;
        if(data.confirmation == 'success'){

          resolve(data);
          commit('updateOneSurvey', data.data);
          
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  updateSurveyData : ({commit, dispatch} , payload) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.put('/api/surveys/' + payload.quoteReference, payload.data)
      .then((response) => {
        console.log(response);
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        let data = response.data;
        if(data.confirmation == 'success'){

          resolve(data);
          commit('updateOneSurvey', data.data);
          
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  makeFinalPayment : ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      let data = null;
      if(payload.token){
        data = {};
        data.token = payload.token;
      }
      HTTPAUTH.post('/api/surveys/' + payload.quoteReference + '/makepayment?type=' + payload.urlParam, data)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        let data = response.data;
        if(data.confirmation == 'success'){
          console.log(data);
          resolve(data);
          commit('updateOneSurvey', data.data);
          if(payload.urlParam === 'invoice'){
            router.push({path : '/purchase-order-number/' + payload.quoteReference})
          } else {
            router.push({path : '/dashboard/surveys'})
          }
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
  },

  loadExtraCompletedSurveys : ({commit, rootState, dispatch}, pagination) => {
    return new Promise((resolve, reject) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.get('/api/surveys?surveyStatus=3&page=' + pagination)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
          let data = response.data;
          if(data.confirmation === 'success'){
            commit('setLoadedSurveys', data.data);
            if(data.data.length > 0){
              resolve(true)
            } else {
              resolve(false);
            }
          } 
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''})
        reject(err);
      })
    })
 },

 getCompletedSurveyForSharing : ({commit}, payload) => {
  return new Promise((resolve, reject) => {

    HTTP.get('/api/surveys/share/' + payload)
    .then((response) => {

        let data = response.data;
        if(data.confirmation === 'success'){
          if(data.data){
            resolve(data)
          } else {
            resolve(false);
          }
        } 
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    })
  })
 } 

}

// mutations
const mutations = {
	addSurvey(state, payload){
		state.surveys.unshift({survey : payload.survey, areas : payload.areas});
	},

  setLoadedSurveyStats(state, payload){
    state.surveyStats = payload;
  },

  resetSurveyData(state){
    console.log('removing survey data');
      state.surveys = [],
      state.surveyStats = []
  },

  setLoadedSurveys(state, payload){
    state.surveys = [...payload, ...state.surveys]
  },

  surveyStatsAlterRequestedQuotes(state, quoteReference){

    state.surveyStats.map((stat) => {
      if(stat.fieldName === 'Quotes Requested'){
        if(stat.count !== 0){
          stat.count = stat.count -1;
        }
      }
    })

  },

  surveyStatsAlterOpenQuotes(state, quoteReference){

    state.surveyStats.map((stat) => {
      if(stat.fieldName === 'Open Quotations'){
        if(stat.count !== 0){
           stat.count = stat.count -1;
        } 
      }
    })

  },

  completeSurveyStats(state){
    state.surveyStats.map((stat) => {
      if(stat.fieldName === 'Total Completed Surveys'){
        
         stat.count = stat.count + 1;
        
      }
      if(stat.fieldName === 'Ongoing Surveys'){
        if(stat.count !== 0){
           stat.count = stat.count -1;
        } 
      }
    })
  },

  updateOpenQuotationStats(state){
    state.surveyStats.map((stat) => {
      if(stat.fieldName === 'Open Quotations'){
        stat.count = stat.count + 1;
      }
    })
  },

  removeOneSurvey(state, quoteReference){
    let newSurveys = state.surveys.filter((surveyData) => {
        return surveyData.survey.quoteReference !== quoteReference
    })
    state.surveys = newSurveys;
  },

  updateOneSurvey(state, newSurvey){
    state.surveys.map((surveyData) => {
       if(surveyData.survey.quoteReference === newSurvey.quoteReference){
        surveyData.survey = newSurvey;
       }
    })
  },

  updateOneSurveyAndAddToBeginning(state, newSurvey){
    let fullSurvey = state.surveys.filter((surveyData) => {
      return surveyData.survey.quoteReference === newSurvey.quoteReference
    })[0]
    let updatedSurveys = state.surveys.filter((surveyData) => {
      return surveyData.survey.quoteReference !== newSurvey.quoteReference
    })
    fullSurvey.survey = newSurvey
    state.surveys = [fullSurvey, ...updatedSurveys]
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/survey.js